import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class EditSalarySettings extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			accyear : [],
			acyear : '',
			depart : [],
			payhe : [],
			emp : [],
			dept : '',
			employee : '',
			payhead : '',
			unit : '',
			ptype : 'Amount',
			_message : '',
			alertClass :'',
			_redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
		
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.dept && this.state.employee && this.state.payhead && this.state.unit){
			$("#showLoader").show();
			PostData('payroll/updatesalset',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Salary Settings Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
		this.getdepartment();
		this.getpayhead();
		this.getemployee();
		this.getacyear();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		
		GetData('employee/getemployee').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					emp : responseJson
				});
			}
		});
	}
	
	/** get Payhead **/
	getpayhead(){
		
		GetData('payroll/getpayhead').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					payhe : responseJson
				});
			}
		});
	}
	
	/** get Designation **/
	getdesignation(){
		
		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					design : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getdetails(){
		$("#showLoader").show();
		GetData('payroll/getsalsetbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					acyear : res[0]['acyear'],
					dept : res[0]['department'],
					employee : res[0]['employee'],
					payhead : res[0]['payhead'],
					unit : res[0]['unit'],
					ptype : res[0]['type']
				});
			}
		});
	}
	
  render() {
	
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/employee/payroll/salarysetting' />);
	}
	
	var dept = this.state.depart;
	var pay = this.state.payhe;
	var acyear = this.state.accyear;
	var emp = this.state.emp;
	   
	  /** set value to payhead type **/	
	this.phtype = [
		{value : '', name : 'Select'},
		{value : 'Amount', name : 'Amount'},
		{value : 'Percentage', name : 'Percentage'}
	];
	
	  /** get Employee By Department **/
	$("#depart").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'employee/getempbydept/'+fr,function(o){
			$("#employ").html('');
			$('#employ')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Employee- ')); 
			$.each(o,function(key,value){			
				   $('#employ')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.empname)); 	
										
			});	
			
		},'json');
	
	});
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="salform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Salary Settings</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.onBack}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Academic Year <span className="text-danger">*</span></Label>
							  <select name="acyear" onChange={this.onChange} required id="year" className="form-control" value={this.state.acyear}>
								<option value="">Select Academic Year</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Department <span className="text-danger">*</span></Label>
							  <select name="dept" onChange={this.onChange} required id="depart" className="form-control" value={this.state.dept}>
								<option value="">Select Department</option>
								{
									dept.map(function (item) {
										return <option value={item.id }>{item.department}</option>;
									})
								}
							 </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Employee <span className="text-danger">*</span></Label>
							  <select name="employee" onChange={this.onChange} className="form-control" id="employ" value={this.state.employee} required >
								<option value="">Select Employee</option>
								{
									emp.map(function (item) {
										return <option value={item.id }>{item.empname}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Payhead <span className="text-danger">*</span></Label>
							 <select name="payhead" onChange={this.onChange} className="form-control" required value={this.state.payhead}>
								<option value="">Select Payhead</option>
								{
									pay.map(function (item) {
										return <option value={item.id }>{item.payheadname}</option>;
									})
								}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Unit <span className="text-danger">*</span></Label>
							  <Input type="text" name="unit" required onChange={this.onChange} value={this.state.unit} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default EditSalarySettings;


// WEBPACK FOOTER //
// ./src/payroll/SalarySettings/EditSalarySettings.js